import axios from 'axios';
import store from './store';
import router from './router'
import {Loading, Message, MessageBox} from 'element-ui'
import {getHost} from "@/utils";
import * as _ from 'lodash';

const HOST = '/api';

const config = {
    headers: {
        'Content-Type': 'application/json',
    },
    timeout: 500000,
    withCredentials: false,
    loading: null,
    baseURL: getHost(),

}
// 灰度域名下，所有请求统一携带灰度标识
if (window.location.hostname.toLowerCase().includes('gray')) {
    axios.defaults.headers.common.isgray = 'true';
}
axios.defaults.withCredentials = false;//Cookie跨域
let client = axios.create(config);

let loading = null;

// 包装request
client.interceptors.request.use(req => {
    loading = Loading.service({fullscreen: true, text: '疯狂加载中'});
    if (!req.url.startsWith("http")) {
        req.url = HOST + req.url;
    } else {
        // console.log(req.url);
    }
    const state = store.state;
    req.headers.app = encodeURIComponent(state.app);
    if (state && state.user) {
        const auth = 'Bearer ' + state.user.jwt;
        req.headers.Authorization = auth;
    }
    return req;
});

// 辅助函数：获取 URL 的 Pathname
function getPathname(url) {
    try {
        // 如果 URL 是相对路径，则以当前页面的 origin 作为基准
        const parsedUrl = new URL(url, window.location.origin);
        return parsedUrl.pathname;
    } catch (e) {
        console.error('无法解析URL:', url, e);
        return '';
    }
}

// 解析response
client.interceptors.response.use(async (rsp) => {
    loading.close();
    // 这个是强制更新要用的，获取请求的 pathname
    const requestPath = getPathname(rsp.config.url);
    // 如果请求的路径为 '/version.json'，直接返回响应对象
    if (_.includes(['/version.json'], requestPath)) {
        return rsp;
    }
    // 获取 Content-Type 头信息
    const contentType = rsp.headers['content-type'] || '';
    // 检查 Content-Type 是否包含 'application/json'
    if (_.includes(contentType, 'application/json')) {
        let data = rsp.data;
        // 传回来的是二进制数据，需要解析成json
        if (data.errno === undefined) {
            try {
                const text = await data.text(); // 现代浏览器Blob有text方法！
                data = JSON.parse(text);
            } catch (e) {
                throw e
            }
        }
        // 正常返回的json数据
        if (data.errno !== 0) {
            Message.error({message: data.errmsg});
            // 重定向到login，说明token过期了
            if (data.errno === 1000) {
                router.push('/login');
            }
            throw new Error();
        }
        return data.data;
    } else {
        return rsp;
    }

}, async (err) => {
    loading.close()
    if (err && err.response) {
        // 返回码为401，说明登录token已经过期，直接弹窗让用户重新登登录
        if (err.response.status === 401) {
            MessageBox.alert('当前登录token已过期，请刷新页面来重新登录', '警告', {
                showClose: false,
                showConfirmButton: false,
            });
        }
        if (!err.response.data) {
            switch (err.response.status) {
                case 400:
                    err.message = '请求错误(400)';
                    break;
                case 401:
                    err.message = '未授权，请重新登录(401)';
                    break;
                case 403:
                    err.message = '拒绝访问(403)';
                    break;
                case 404:
                    err.message = '请求出错(404)';
                    break;
                case 408:
                    err.message = '请求超时(408)';
                    break;
                case 500:
                    err.message = '服务器错误(500)';
                    break;
                case 501:
                    err.message = '服务未实现(501)';
                    break;
                case 502:
                    err.message = '网络错误(502)';
                    break;
                case 503:
                    err.message = '服务不可用(503)';
                    break;
                case 504:
                    err.message = '网络超时(504)';
                    break;
                case 505:
                    err.message = 'HTTP版本不受支持(505)';
                    break;
                default:
                    err.message = `连接出错(${err.response.status})!`;
            }
        } else {
            if (err.response.data instanceof Blob) {
                const text = await err.response.data.text();
                err.message = text;
            } else {
                err.message = err.response.data;
            }
        }
    }
    Message.error({message: err.message});
    return Promise.reject(err);
})

export default client;
